import * as R from 'ramda';
import { parseIfNumber } from './parseIfNumber';
const shouldParseIndex = R.pipe(R.match(/\[\d+\]/), R.prop('length'));
const parseIndex = R.pipe(R.split(/\[|\]/), R.filter(Boolean), R.map(parseIfNumber));
export function stringPathToArrayPath(stringPath) {
    return R.compose(R.chain(R.when(shouldParseIndex, parseIndex)), R.split('.'), R.defaultTo(''))(stringPath);
}
export function ensureArrayPath(path) {
    return R.when(R.is(String), stringPathToArrayPath)(path);
}
export default stringPathToArrayPath;
